import { computed, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceClaimingApiService } from '@shure/cloud/device-management/devices/data-access';
import { PrismDialogRef } from '@shure/prism-angular-components';
import { FooterButtonsConfig, StepConfig } from '@shure/shared/angular/ui/components/step-router';

import { AddDevicesDialogComponent } from '../add-devices-dialog.component';

import { Step3ConfirmationComponent } from './step3-confirmation.component';

@Injectable()
export class Step3ConfirmationConfig implements StepConfig {
	private readonly claimOpInProgress = toSignal(this.deviceClaimingService.claimOpInProgress$, {
		initialValue: false
	});

	public readonly id = 'step3-confirmation';
	public readonly label = this.transloco.translate('cloud.shared.button-text.confirm');
	public readonly component = signal(Step3ConfirmationComponent);
	public readonly footerButtons = signal<FooterButtonsConfig>({
		left: [],
		right: [
			{
				id: 'sh-add-devices-step3-done',
				testId: 'step3-done-button',
				text: this.transloco.translate('cloud.shared.button-text.done'),
				isEnabled: computed(() => !this.claimOpInProgress()),
				onClick: (): void => {
					this.dialogRef.close();
				}
			}
		]
	});

	constructor(
		private readonly transloco: TranslocoService,
		private readonly dialogRef: PrismDialogRef<AddDevicesDialogComponent>,
		private readonly deviceClaimingService: DeviceClaimingApiService
	) {}
}
